import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { SkapaText } from '@inter-ikea-guida/skapa';
const StyledFooter = styled.footer `
  height: 90px;
  display: flex;
  align-items: center;
`;
/**
 * Custom footer for GUIDA applications. This is a clone of the KOMPIS footer.
 * The reason for this clone is that the KOMPIS footer contains margins that makes it difficult to place in our scrolling flow.
 */
export const GuidaFooter = ({ isLoading }) => {
    if (isLoading) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(StyledFooter, { children: _jsxs(SkapaText, { textStyle: 'Body.M', children: ["\u00A9 Inter IKEA Systems B.V. 1999-", new Date().getFullYear()] }) }));
};
//# sourceMappingURL=GuidaFooter.js.map